"use strict";
/* tslint:disable */
var TUKSPSlipMode = (function () {
    "use strict";
    var api = {};
    // Overrides ComboSPSlipMode
    api.updateView = function () {
        TUniSlip.buildView();
    };
    // Template logic splitter
    api.buildOptions = function (selections) {
        Modes.calcComboVariants(this);
        this.calcSystemVariants();
        return TMultiOptions.buildUKMultiplesOptions(this, selections);
    };
    // Adapter for Array.push template implementation
    api.buildSelectionInnerView = function (selection, selectionUpdated) {
        return TBuildLine.buildInnerView(selection, this, { buildInner: true, updated: selectionUpdated, isSP: true });
    };
    api.buildHeader = function () {
        return `<div class='${this.getHeaderStylesString()}' id='jsUkSinglesHeader'>${this.getHeaderText()}</div>`;
    };
    api.getHeaderText = function () {
        return $dict.bs("Singles");
    };
    api.getHeaderStylesString = function () {
        return "ukSlipHeading";
    };
    return api;
}());
window.TUKSPSlipMode = TUKSPSlipMode;
//# sourceMappingURL=TUKSPSlipMode.js.map